import { fontSize } from "@mui/system";
import { makeStyles } from "tss-react/mui";

export type IStyleParams = {
  locale: string;
  selectedColor: string;
  fontSize: string;
};

const useStyles = makeStyles<{ params: IStyleParams }>({
  name: "appTitle",
  uniqId: "app_title",
})((theme, { params }, classes) => {
  return {
    title: {
      color: params.selectedColor,
      fontFamily:
        params.locale === "en-US"
          ? "Montserrat"
          : params.locale === "zh-CN"
          ? "Noto Sans SC"
          : "Noto Sans TC",
      fontWeight: "700",
      fontSize: params.fontSize,
      lineHeight: "57.92px",
      //padding: "50px 0",
      textAlign: "center",
      letterSpacing: params.locale ? 0 : "3.6px",
      [theme.breakpoints.down("sm")]: {
        padding: "32px 0 16px 0",
      },
    },
  };
});

export default useStyles;
